var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.menuData.length
    ? _c(
        "div",
        {
          on: {
            click: function($event) {
              _vm.$refs.menuBar.showTabOper = false
            }
          }
        },
        [
          _vm.menuInit
            ? _c("menu-bar", {
                ref: "menuBar",
                attrs: { homeObj: _vm.homeObj },
                on: { switchLeftSide: _vm.switchLeftSide }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "home-content",
              class: {
                "left-home-content": !_vm.MENUCONFIG.STYLE.isTop,
                "left-home-big": _vm.leftSideHide,
                "has-not-tab": !_vm.MENUCONFIG.STYLE.isTab
              }
            },
            [
              _c(
                "div",
                { staticClass: "page-content" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _vm.MENUCONFIG.STYLE.isTab
                        ? _c(
                            "keep-alive",
                            { attrs: { include: _vm.cachedViews } },
                            [_c("router-view")],
                            1
                          )
                        : _c("router-view")
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("eleSign", { ref: "homeEleSign", on: { ok: _vm.handleOk } }),
          _vm._v(" "),
          _c("aprvStatusDialog", { ref: "aprvStatusDialog" }),
          _vm._v(" "),
          _c("userService", {
            ref: "userService",
            attrs: { fileId: _vm.signList[_vm.userServiceIndex] },
            on: {
              "update:fileId": function($event) {
                return _vm.$set(_vm.signList, _vm.userServiceIndex, $event)
              },
              "update:file-id": function($event) {
                return _vm.$set(_vm.signList, _vm.userServiceIndex, $event)
              },
              ok: _vm.userServiceOk
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e23e94f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e23e94f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-frame/home.vue
// module id = /Led
// module chunks = 1